module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_15-477d4229616962679a9140478ac0ab36.jpg";